export default __webpack_public_path__ + "static/media/SusciucAnastasia.234e7269.jpg";